/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdatePraetorBody = zod
	.object({
		disabled: zod
			.boolean()
			.optional()
			.describe('Whether this praetor rejects new checkout creation'),
		live_version: zod
			.string()
			.optional()
			.describe('Set to \"latest\" or a specific praetor version ID'),
		name: zod.string().optional().describe('Praetor name')
	})
	.describe('Request body for updating praetor pointers');

export type UpdatePraetorBody = zod.input<typeof UpdatePraetorBody>;
export type UpdatePraetorBodyOutput = zod.output<typeof UpdatePraetorBody>;
